import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubMenuItem',
  props: {
    item: null,
    isCurrentPage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    item: INavigationViewObject,
    isCurrentPage: boolean
}



const itemComponentName = computed<string>(() => {
    let componentName = 'sub-menu-item-default';
    const hasLinkType = props.item.linkType;

    if (hasLinkType) {
        componentName = `sub-menu-item-${props.item.linkType}`;
    }

    return componentName;
});


return { __sfc: true,props, itemComponentName }
}

})